import React from 'react';
import ContentLoader from 'react-content-loader';
import { RowItem } from './styles';

const Row = ({ ...rest }) => {
  const widthSet = 360;
  const minHeight = 45;

  return (
    <RowItem width={Number(widthSet)} height={minHeight} {...rest}>
      <ContentLoader height={minHeight} width={widthSet} speed={1}>
        <rect x="0" y="0" rx="50" ry="50" width="40" height="40" />
        <rect x="50" y="5" rx="4" ry="4" width="300" height="20" />
        <rect x="50" y="30" rx="3" ry="3" width="230" height="10" />
      </ContentLoader>
    </RowItem>
  );
};

export default Row;
